import * as o from "react";
import t from "../lib/IconBase.es.js";
import s from "../defs/CalendarDots.es.js";
const a = o.forwardRef((e, r) => /* @__PURE__ */ o.createElement(t, { ref: r, ...e, weights: s }));
a.displayName = "CalendarDotsIcon";
const c = a;
export {
  c as CalendarDots,
  a as CalendarDotsIcon
};
